import {
  Attachment,
  AttachmentAction,
} from './components/file-upload/component';
import { v4 as getUuid } from 'uuid';

export class AttachmentSet {
  displayedAttachments: DisplayedAttachment[] = [];

  get pendingAttachments(): File[] {
    return this.displayedAttachments.flatMap((at) =>
      at.pending ? [at.pendingFile] : [],
    );
  }

  update(act: AttachmentAction): void {
    switch (act.action) {
      case 'add':
        this.displayedAttachments = [
          ...this.displayedAttachments,
          ...act.attachments.map(previewOfPendingAttachment),
        ];
        break;
      case 'remove':
        const i = this.displayedAttachments.findIndex(
          (a) => a.id === act.attachmentId,
        );
        if (i === -1) {
          throw new Error("BUG: tried to remove attachment that doesn't exist");
        }
        this.displayedAttachments = [...this.displayedAttachments];
        const [removed] = this.displayedAttachments.splice(i, 1);
        if (removed.pending) {
          URL.revokeObjectURL(removed.file.signedUrl);
        }
        break;
    }
  }

  reset(): void {
    this.clear();
    this.displayedAttachments = [];
  }

  clear(): void {
    for (const at of this.displayedAttachments) {
      if (at.pending) {
        URL.revokeObjectURL(at.file.signedUrl);
      }
    }
  }
}

export type DisplayedAttachment = ExistingAttachment | PendingAttachment;

export interface ExistingAttachment extends Attachment {
  pending: false;
}

export interface PendingAttachment extends Attachment {
  pending: true;
  pendingFile: File;
}

function previewOfPendingAttachment(f: File): PendingAttachment {
  const signedUrl = URL.createObjectURL(f);
  return {
    id: getUuid(),
    label: f.name,
    pending: true,
    pendingFile: f,
    file: {
      fileName: f.name,
      signedUrl,
    },
  };
}
